import { BottomSheetModalMethods } from '@gorhom/bottom-sheet/lib/typescript/types'
import React, { RefObject, createContext, useContext } from 'react'

const DialogModalContext = createContext<RefObject<BottomSheetModalMethods> | null>(null)

type DialogModalProviderProps = {
  dialogModalRef: RefObject<BottomSheetModalMethods>
  children: React.ReactNode
}

const DialogModalProvider = ({ dialogModalRef, children }: DialogModalProviderProps) => {
  return (
    <DialogModalContext.Provider value={dialogModalRef}>{children}</DialogModalContext.Provider>
  )
}

const useDialogModal = () => {
  return useContext(DialogModalContext)
}

export { DialogModalProvider, useDialogModal }
